import { readCart } from '@theme/fate-cart-sync';
import { packDockView, twoDockView } from '@theme/fate-pack-builder-model';
const panel = document.querySelector('[data-fate-pack]');
if (panel && !panel.dataset.initialized) {
  panel.dataset.initialized = 'true';
  document.documentElement.classList.add('fate-pack-active');
  const slots = [...panel.querySelectorAll('[data-pack-slot]')];
  const action = panel.querySelector('[data-pack-action]');
  const two = panel.dataset.fatePackOffer === 'two';
  const more = panel.querySelector('[data-pack-more-item]');
  const membership = new Map();
  let timer, running = false, pending = false, opening = false;
  const error = text => { panel.querySelector('[data-pack-error]').textContent = text; };
  function seed(scope) {
    scope.querySelectorAll('[data-cart-identity][data-fate-promo-four]').forEach(row => {
      try { membership.set(String(JSON.parse(row.dataset.cartIdentity).variant), (two ? row.dataset.fatePromoThree : row.dataset.fatePromoFour) === 'true'); } catch (_) {}
    });
  }
  function render(view) {
    panel.setAttribute('aria-busy', 'false');
    panel.dataset.ready = 'true';
    const slotCount = two ? view.slotCount : slots.length;
    const firstPosition = two ? view.firstVisiblePosition : view.completedQuantity;
    panel.dataset.slotCount = String(slotCount);
    if (more) {
      more.hidden = !view.overflow;
      more.querySelector('button').setAttribute('aria-label', `Ver ${view.overflow} prendas anteriores y el carrito completo`);
    }
    slots.forEach((slot, i) => {
      slot.closest('li').hidden = i >= slotCount;
      const item = view.picked[i], img = slot.querySelector('[data-pack-image]'), size = slot.querySelector('[data-pack-size]');
      slot.disabled = !item;
      slot.querySelector('[data-pack-number]').hidden = Boolean(item);
      img.hidden = !item; size.hidden = !item;
      if (item) {
        const src = item.featured_image?.url || item.image;
        if (src && img.getAttribute('src') !== src) img.src = src;
        img.hidden = !src;
        size.textContent = item.options_with_values?.find(o => /^(size|talla|tamaño)$/i.test(o.name))?.value || item.variant_title || '';
        slot.setAttribute('aria-label', `${item.product_title}, ${item.variant_title}. Editar en el carrito`);
      } else {slot.setAttribute('aria-label', `Prenda ${firstPosition + i + 1} pendiente`);img.removeAttribute('src');}
      slot.querySelector('[data-pack-number]').textContent=String(firstPosition+i+1).padStart(2,'0');
    });
    panel.querySelector('[data-pack-title]').textContent = view.title;
    panel.dataset.applied = String(view.applied);
    panel.querySelector('[data-pack-status]').textContent = view.status;
  }
  async function sync() {
    if (running) { pending = true; return; }
    running = true;
    try {
      const cart = await readCart(); seed(document);
      const ids = [...membership].filter(([,value]) => value).map(([id]) => id);
      render(two ? twoDockView(cart.items, ids) : packDockView(cart.items, ids)); error('');
    } catch (_) {
      panel.querySelector('[data-pack-title]').textContent = two ? 'ARMA TU 2X1' : 'ARMA TU 5X1';
      panel.dataset.applied = 'false';
      error('No pudimos actualizar tu pack. Abre el carrito para continuar.');
      panel.dataset.ready = 'false'; panel.setAttribute('aria-busy', 'false');
      panel.querySelector('[data-pack-status]').textContent = 'REVISA TU CARRITO';
      slots.forEach(slot => { slot.disabled = true; });
      if (more) more.hidden = true;
    } finally { running = false; if (pending) { pending = false; schedule(); } }
  }
  function schedule(event) {
    const sections = event?.detail?.data?.sections || event?.detail?.sections;
    if (!event?.detail?.data?.rendered && sections) for (const html of Object.values(sections)) if (typeof html === 'string' && html.includes('data-fate-promo-four')) seed(new DOMParser().parseFromString(html, 'text/html'));
    clearTimeout(timer); timer = setTimeout(sync, 220);
  }
  async function openDrawer() {
    if (opening) return; opening = true; action.disabled = true;
    try {
      await customElements.whenDefined('cart-drawer-component');
      const drawer = document.querySelector('cart-drawer-component');
      if (!drawer) throw new Error('Abre el carrito desde el menú para continuar.');
      drawer.showDialog();
    } catch (err) { error(err.message); }
    finally { opening = false; action.disabled = false; }
  }
  panel.addEventListener('click', event => { const button = event.target.closest('button'); if (button && !button.disabled) openDrawer(); });
  ['cart:update', 'cart:add', 'cart:change', 'cart:refresh'].forEach(name => document.addEventListener(name, schedule));
  window.addEventListener('pageshow', schedule);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
  new ResizeObserver(() => document.documentElement.style.setProperty('--fate-pack-height', `${panel.offsetHeight}px`)).observe(panel);
  seed(document); sync();
}
